'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpiringContactsController = function () {
  function ExpiringContactsController(authService, userService, loadingService, $scope, $ngConfirm, contactService, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ExpiringContactsController);
    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.contactService = contactService;
    this.growl = growl;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.overrideUserId = null;
    this.contacts = [];

    $scope.$on('dashboard:viewExpiringContactsStats', this.loadStats.bind(this));
    $scope.$on('dashboard:viewExpiringContacts', this.viewExpiringContacts.bind(this));
  }

  (0, _createClass3.default)(ExpiringContactsController, [{
    key: 'loadStats',
    value: function loadStats(evt, params) {
      var ctrl = this;

      ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');

      this.overrideUserId = params ? params.userId : null;

      ctrl.userService.expiringContactsStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
        ctrl.pagination.totalItems = response.data;
        ctrl.onLoadStats({ count: response.data });
      }).finally(function () {
        ctrl.loadingService.hideLoading('contactList');
      });
    }
  }, {
    key: 'viewExpiringContacts',
    value: function viewExpiringContacts(evt, params) {
      var _this = this;

      //Toggle Event coming from dashboard instead of page change, skip the method
      if (evt && this.contacts.length && !params.reload) {
        return;
      }
      var ctrl = this;

      ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');

      ctrl.userService.expiringContacts(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage).then(function (response) {
        ctrl.contacts = response.data;
        ctrl.contacts = (0, _lodash.map)(ctrl.contacts, _this.convertContact.bind(_this));
      }).finally(function () {
        ctrl.loadingService.hideLoading('contactList');
      });
    }
  }, {
    key: 'nukeContactConfirm',
    value: function nukeContactConfirm(contact) {
      var _this2 = this;

      this.$scope.contact = contact;

      this.$ngConfirm({
        title: 'Delete Contact',
        contentUrl: 'templates/dashboard/nukeContactConfirmTemplate',
        typeAnimation: false,
        columnClass: 'm',
        type: 'red',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Anonymize this Contact',
            btnClass: 'btn-danger',
            action: function action() {
              _this2.nukeContact(contact);
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'nukeContact',
    value: function nukeContact(contact) {
      var _this3 = this;

      this.loadingService.showLoading('contactList', 'Anonymizing Contact ...');

      this.contactService.anonymize(contact.contactId).then(function (response) {
        _this3.growl.success('Contact Anonymized Successfully ...', { ttl: 5000 });
        _this3.contacts = (0, _lodash.without)(_this3.contacts, contact);
      }).finally(function () {
        _this3.loadingService.hideLoading('contactList');
      });
    }
  }, {
    key: 'isEmptyOrSpaces',
    value: function isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null;
    }
  }, {
    key: 'convertContact',
    value: function convertContact(contact) {
      var reason = void 0;

      switch (contact.category) {
        case 1:
          reason = 'Contact has been inactive for over ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true);
          break;

        case 2:
          reason = 'Due date for contact\'s promise lapsed ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
          break;

        case 3:
          reason = 'A Lost Enquiry for contact was created ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
          break;

        case 4:
          reason = 'An Open Enquiry for contact was created ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
          break;

        case 5:
          reason = 'An Enquiry was Closed for contact ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
          break;
      }

      return {
        contactId: contact.contactId,
        contactName: this.isEmptyOrSpaces(contact.contactName) ? 'Blank' : contact.contactName,
        timeRemaining: contact.timeRemaining,
        timeRemainingText: contact.timeRemaining,
        salesPerson: contact.salesPerson,
        lastModified: contact.lastModifiedBySalesPerson,
        reason: reason
      };
    }
  }]);
  return ExpiringContactsController;
}();

exports.default = ExpiringContactsController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/expiringContacts/expiringContacts.controller.js